var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ptc_container"
  }, [_c('div', {
    staticClass: "join_contant"
  }, [_c('h3', {
    staticClass: "login_tit"
  }, [_vm._v("회원가입")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.currentStep === 1,
      expression: "this.currentStep === 1"
    }],
    staticClass: "section1"
  }, [_vm._m(0), _c('div', {
    staticClass: "terms"
  }, [_c('ul', {
    staticClass: "terms"
  }, [_c('li', {
    staticClass: "collapsible all"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "ag-chk all"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.allCheckFlag,
      expression: "allCheckFlag"
    }],
    attrs: {
      "type": "checkbox",
      "name": "allChk",
      "id": "allChk"
    },
    domProps: {
      "checked": Array.isArray(_vm.allCheckFlag) ? _vm._i(_vm.allCheckFlag, null) > -1 : _vm.allCheckFlag
    },
    on: {
      "click": _vm.allCheck,
      "change": function ($event) {
        var $$a = _vm.allCheckFlag,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.allCheckFlag = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.allCheckFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.allCheckFlag = $$c;
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "allChk"
    }
  }, [_vm._v("모든 약관에 동의합니다.")])])])]), _c('li', {
    staticClass: "collapsible"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "ag-chk"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.agreeIdList.TERM.checkFlag,
      expression: "agreeIdList.TERM.checkFlag"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ag-chk2",
      "id": "ag-chk2"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeIdList.TERM.checkFlag) ? _vm._i(_vm.agreeIdList.TERM.checkFlag, null) > -1 : _vm.agreeIdList.TERM.checkFlag
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.agreeIdList.TERM.checkFlag,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.agreeIdList.TERM, "checkFlag", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.agreeIdList.TERM, "checkFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.agreeIdList.TERM, "checkFlag", $$c);
        }
      }
    }
  }), _vm._m(1)]), _c('a', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.section1-content",
      modifiers: {
        "section1-content": true
      }
    }],
    class: {
      'selected': _vm.agreeIdList.TERM.collapseFlag
    },
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleCollapse(`TERM`);
      }
    }
  })]), _c('b-collapse', {
    attrs: {
      "id": "section1-content"
    }
  }, [_c('div', {
    staticClass: "ag-content"
  }, [_c('div', {
    staticClass: "scroll-custom"
  }, [_c('h6', [_vm._v(_vm._s(_vm.agreeIdList.TERM.scrollContent.title))]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.agreeIdList.TERM.scrollContent.content)
    }
  })])])])], 1), _c('li', {
    staticClass: "collapsible"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "ag-chk"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.agreeIdList.PRIVACY.checkFlag,
      expression: "agreeIdList.PRIVACY.checkFlag"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ag-chk1",
      "id": "ag-chk1"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeIdList.PRIVACY.checkFlag) ? _vm._i(_vm.agreeIdList.PRIVACY.checkFlag, null) > -1 : _vm.agreeIdList.PRIVACY.checkFlag
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.agreeIdList.PRIVACY.checkFlag,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.agreeIdList.PRIVACY, "checkFlag", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.agreeIdList.PRIVACY, "checkFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.agreeIdList.PRIVACY, "checkFlag", $$c);
        }
      }
    }
  }), _vm._m(2)]), _c('a', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.section2-content",
      modifiers: {
        "section2-content": true
      }
    }],
    class: {
      'selected': _vm.agreeIdList.PRIVACY.collapseFlag
    },
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleCollapse(`PRIVACY`);
      }
    }
  })]), _c('b-collapse', {
    attrs: {
      "id": "section2-content"
    }
  }, [_c('div', {
    staticClass: "ag-content"
  }, [_c('div', {
    staticClass: "scroll-custom"
  }, [_c('h6', [_vm._v(_vm._s(_vm.agreeIdList.PRIVACY.scrollContent.title))]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.agreeIdList.PRIVACY.scrollContent.content)
    }
  })])])])], 1), _c('li', {
    staticClass: "collapsible"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "ag-chk"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.agreeIdList.AGE.checkFlag,
      expression: "agreeIdList.AGE.checkFlag"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ag-chk3",
      "id": "ag-chk3"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeIdList.AGE.checkFlag) ? _vm._i(_vm.agreeIdList.AGE.checkFlag, null) > -1 : _vm.agreeIdList.AGE.checkFlag
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.agreeIdList.AGE.checkFlag,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.agreeIdList.AGE, "checkFlag", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.agreeIdList.AGE, "checkFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.agreeIdList.AGE, "checkFlag", $$c);
        }
      }
    }
  }), _vm._m(3)])])])])]), _c('div', {
    staticClass: "bottom_area"
  }, [_c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_c('a', {
    staticClass: "btm_btn",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function ($event) {
        return _vm.step(-1);
      }
    }
  }, [_vm._v("취소")])]), _c('li', [_c('a', {
    staticClass: "btm_btn bk",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function ($event) {
        return _vm.step(1);
      }
    }
  }, [_vm._v("다음")])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.currentStep === 2,
      expression: "this.currentStep === 2"
    }],
    staticClass: "section2"
  }, [_vm._m(4), _c('h3', {
    staticClass: "form_tit"
  }, [_vm._v("기본 정보")]), _c('div', {
    staticClass: "form_cont"
  }, [_c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_vm._m(5), _c('div', {
    staticClass: "column_input"
  }, [_c('ul', {
    staticClass: "inp_column btn"
  }, [_c('li', [_c('input', {
    class: _vm.input.loginId.validMessage != null && _vm.input.loginId.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "name": "loginId",
      "maxlength": "80"
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.loginId.validMessage != null && _vm.input.loginId.validMessage != '',
      expression: "input.loginId.validMessage != null && input.loginId.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.loginId.validMessage))])]), _c('li', {
    staticClass: "col_btn"
  }, [_c('button', {
    staticClass: "inp_btn",
    attrs: {
      "type": "button",
      "disabled": _vm.duplicateCheck
    },
    on: {
      "click": _vm.duplicateCheckId
    }
  }, [_vm._v("중복확인")])])])])]), _c('li', [_vm._m(6), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.name.value,
      expression: "input.name.value"
    }],
    class: _vm.input.name.validMessage != null && _vm.input.name.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": _vm.input.name.value
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input.name, "value", $event.target.value);
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.name.validMessage != null && _vm.input.name.validMessage != '',
      expression: "input.name.validMessage != null && input.name.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(" " + _vm._s(_vm.input.name.validMessage))])])])]), _c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_vm._m(7), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    class: _vm.input.password.validMessage != null && _vm.input.password.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "password",
      "name": "password",
      "maxlength": "80",
      "placeholder": "영문 대･소문자, 숫자, 특수문자를 포함, 최소 8자 이상."
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('div', {
    staticClass: "pw_danger_area"
  }, [_c('div', {
    staticClass: "pw_danger_bar_wrap"
  }, [_c('div', {
    staticClass: "pw_danger_bar weak",
    class: _vm.passwordStrength == 0 || _vm.passwordStrength == 1 ? `active` : ``
  }, [_c('span')]), _c('div', {
    staticClass: "pw_danger_bar medium",
    class: _vm.passwordStrength == 2 ? `active` : ``
  }, [_c('span')]), _c('div', {
    staticClass: "pw_danger_bar strong",
    class: _vm.passwordStrength == 3 ? `active` : ``
  }, [_c('span')])]), _c('div', {
    staticClass: "pw_danger_txt"
  }, [_vm.passwordStrength == 0 || _vm.passwordStrength == 1 ? _c('p', {
    staticClass: "danger_weak"
  }, [_vm._v("Weak")]) : _vm.passwordStrength == 2 ? _c('p', {
    staticClass: "danger_medium"
  }, [_vm._v("Medium")]) : _c('p', {
    staticClass: "danger_strong"
  }, [_vm._v("Strong")])])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.password.validMessage != null && _vm.input.password.validMessage != '',
      expression: "input.password.validMessage != null && input.password.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.password.validMessage))])])]), _c('li', [_vm._m(8), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    class: _vm.input.passwordConfirm.validMessage != null && _vm.input.passwordConfirm.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "password",
      "name": "passwordConfirm",
      "maxlength": "80",
      "placeholder": "영문 대･소문자, 숫자, 특수문자를 포함, 최소 8자 이상."
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.passwordConfirm.validMessage != null && _vm.input.passwordConfirm.validMessage != '',
      expression: "input.passwordConfirm.validMessage != null && input.passwordConfirm.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.passwordConfirm.validMessage))])])])]), _c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_vm._m(9), _c('div', {
    staticClass: "column_input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.companyCode.value,
      expression: "input.companyCode.value"
    }],
    style: {
      borderColor: _vm.input.companyCode.validMessage != null && _vm.input.companyCode.validMessage != '' ? 'red' : ''
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.input.companyCode, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.sortedCompanyList, function (opt, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": opt.value,
        "selected": index == 0 ? true : false
      }
    }, [_vm._v(" " + _vm._s(opt.text) + " ")]);
  }), 0), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.companyCode.validMessage != null && _vm.input.companyCode.validMessage != '',
      expression: "input.companyCode.validMessage != null && input.companyCode.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.companyCode.validMessage))])])]), _c('li', [_vm._m(10), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    class: _vm.input.position.validMessage != null && _vm.input.position.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "name": "position",
      "maxlength": "80",
      "placeholder": "직책을 입력하세요."
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.position.validMessage != null && _vm.input.position.validMessage != '',
      expression: "input.position.validMessage != null && input.position.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.position.validMessage))])])])]), _c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_vm._m(11), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    class: _vm.input.companyPhone.validMessage != null && _vm.input.companyPhone.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "name": "companyPhone",
      "maxlength": "80",
      "placeholder": "직장전화번호를 입력하세요."
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.companyPhone.validMessage != null && _vm.input.companyPhone.validMessage != '',
      expression: "input.companyPhone.validMessage != null && input.companyPhone.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.companyPhone.validMessage))])])]), _c('li', [_vm._m(12), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    class: _vm.input.mobile.validMessage != null && _vm.input.mobile.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "name": "mobile",
      "maxlength": "80",
      "placeholder": "휴대전화를 입력하세요."
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.mobile.validMessage != null && _vm.input.mobile.validMessage != '',
      expression: "input.mobile.validMessage != null && input.mobile.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.mobile.validMessage))])])])]), _c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_vm._m(13), _c('div', {
    staticClass: "column_input"
  }, [_c('input', {
    class: _vm.input.fax.validMessage != null && _vm.input.fax.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "name": "fax",
      "maxlength": "80",
      "placeholder": "팩스번호를 입력하세요."
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.fax.validMessage != null && _vm.input.fax.validMessage != '',
      expression: "input.fax.validMessage != null && input.fax.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(_vm._s(_vm.input.fax.validMessage))])])])])]), _c('h3', {
    staticClass: "form_tit"
  }, [_vm._v("이메일 인증")]), _c('div', {
    staticClass: "form_cont"
  }, [_c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_vm._m(14), _c('div', {
    staticClass: "column_input"
  }, [_c('ul', {
    staticClass: "inp_column btn"
  }, [_c('li', [_c('input', {
    class: _vm.input.email.validMessage != null && _vm.input.email.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "name": "email",
      "maxlength": "80",
      "readonly": _vm.emailAuth.flag
    },
    on: {
      "input": _vm.inputListener,
      "keydown": _vm.keydownListener
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.input.email.validMessage != null && _vm.input.email.validMessage != '',
      expression: "input.email.validMessage != null && input.email.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(" " + _vm._s(_vm.input.email.validMessage) + " ")])]), _c('li', {
    staticClass: "col_btn"
  }, [_c('button', {
    staticClass: "inp_btn",
    attrs: {
      "type": "button",
      "disabled": _vm.emailAuth.flag
    },
    on: {
      "click": _vm.sendEmailAuthCode
    }
  }, [!_vm.emailAuth.sendYn ? _c('span', [_vm._v("인증번호 발송")]) : _c('span', [_vm._v("인증번호 재발송")])])])])])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.emailAuth.sendYn,
      expression: "emailAuth.sendYn"
    }]
  }, [_vm._m(15), _c('div', {
    staticClass: "column_input"
  }, [_c('ul', {
    staticClass: "inp_column btn"
  }, [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.emailAuth.value,
      expression: "emailAuth.value"
    }],
    class: _vm.emailAuth.validMessage != null && _vm.emailAuth.validMessage != '' ? `validation_error` : ``,
    attrs: {
      "type": "text",
      "maxlength": "80",
      "readonly": _vm.emailAuth.flag
    },
    domProps: {
      "value": _vm.emailAuth.value
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.emailAuth, "value", $event.target.value);
      }
    }
  }), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.displayTime))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.emailAuth.validMessage != null && _vm.emailAuth.validMessage != '',
      expression: "emailAuth.validMessage != null && emailAuth.validMessage != ''"
    }],
    staticClass: "validation_text"
  }, [_vm._v(" " + _vm._s(_vm.emailAuth.validMessage) + " ")])]), _c('li', {
    staticClass: "col_btn"
  }, [_c('button', {
    staticClass: "inp_btn",
    attrs: {
      "type": "button",
      "disabled": _vm.emailAuth.flag
    },
    on: {
      "click": _vm.verificationEmailAuthCode
    }
  }, [_vm._v(" 인증번호 확인 ")])])])])])])]), _c('div', {
    staticClass: "bottom_area"
  }, [_c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_c('a', {
    staticClass: "btm_btn",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function ($event) {
        return _vm.step(-1);
      }
    }
  }, [_vm._v("뒤로")])]), _c('li', [_c('a', {
    staticClass: "btm_btn bk",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function ($event) {
        return _vm.step(1);
      }
    }
  }, [_vm._v("다음")])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.currentStep === 3,
      expression: "this.currentStep === 3"
    }],
    staticClass: "section3"
  }, [_vm._m(16), _c('div', [_vm._m(17), _c('div', {
    staticClass: "bottom_area"
  }, [_c('ul', {
    staticClass: "column col_1"
  }, [_c('li', [_c('a', {
    staticClass: "btm_btn bk",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push(`/account/login`);
      }
    }
  }, [_vm._v("로그인")])])])])])])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "sign-up-step"
  }, [_c('li', {
    staticClass: "on"
  }, [_c('span', [_vm._v("1. 약관동의")])]), _c('li', [_c('span', [_vm._v("2. 정보입력")])]), _c('li', [_c('span', [_vm._v("3. 가입완료")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "ag-chk2"
    }
  }, [_vm._v("허브 플랫폼 이용약관"), _c('em', [_vm._v("(필수)")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "ag-chk1"
    }
  }, [_vm._v("개인정보 수집 및 이용 동의서"), _c('em', [_vm._v("(필수)")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "ag-chk3"
    }
  }, [_vm._v("만 14세 이상입니다."), _c('em', [_vm._v("(필수)")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "sign-up-step"
  }, [_c('li', {
    staticClass: "on"
  }, [_c('span', [_vm._v("1. 약관동의")])]), _c('li', {
    staticClass: "on"
  }, [_c('span', [_vm._v("2. 정보입력")])]), _c('li', [_c('span', [_vm._v("3. 가입완료")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("아이디"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("이름"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("비밀번호"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("비밀번호 확인"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("소속(직장명)"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("직책"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("직장전화번호"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("휴대전화"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("팩스")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("이메일"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("인증번호"), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "sign-up-step"
  }, [_c('li', {
    staticClass: "on"
  }, [_c('span', [_vm._v("1. 약관동의")])]), _c('li', {
    staticClass: "on"
  }, [_c('span', [_vm._v("2. 정보입력")])]), _c('li', {
    staticClass: "on"
  }, [_c('span', [_vm._v("3. 가입완료")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member_complete space"
  }, [_c('h3', [_vm._v("회원가입을 완료했습니다.")]), _c('p', [_vm._v("입력하신 정보로 회원가입을 완료했습니다. "), _c('br'), _vm._v("입력하신 계정 정보로 로그인 해 주세요.")])]);

}]

export { render, staticRenderFns }